import { useEffect, useState } from "react";
import { useAuthState } from "../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../Navbar";
import MainCotent from "../../MainCotent";
import Siderbar from "../../Sidebar";
import { useNavigate } from "react-router-dom";
import { AdmindashCountDataAPI } from "../../../Helper/Redux/AdminDashboardCountAPI/AdminDashboardCountAPISlice";
import { Loading } from "../../../Helper/LogoLoader/LogoLoader";



function AdminDashboard() {
    const [isopen, setIsOpen] = useState(false);

    const navigate = useNavigate()

    // console.log(Data.logoPhoto)

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    // const currentYear = new Date().getFullYear();

    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)

    const toggle = () => {
        setIsOpen(!isopen);

    };

    const [Countdata, setCountdata] = useState({})

    const handleGetCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

   
    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            M_TableUserMasterID: UserID,
            token: token,
            handleGetCount: handleGetCount
        }

        if ((YearValue != '' && YearValue != null && YearValue != "0") && (MonthValue != '' && MonthValue != null && MonthValue != "0")) {
            dispatch(AdmindashCountDataAPI({ data }))
        }
    }, [YearValue, MonthValue])



    const { Data, isLoading } = useSelector(state => state.AdmindashCountData)

    return (
        <>
            {/* <div className="wrapper"> */}
            {isLoading && <Loading />}
            <div className="backrounf">
                <div className="container-scroller ">
                    <Navbar
                        setYearValue={setYearValue}
                        setYearLabel={setYearLabel}
                        setMonthValue={setMonthValue}
                        setMonthLabel={setMonthLabel}
                        toggle={toggle}
                        isopen={isopen} />
                    <div className="container-fluid page-body-wrapper">
                        <Siderbar isopen={isopen} toggle={toggle} active="AdminDashboard" />
                        <div className="main-panel" style={{ width: isopen ? "calc(100%  - 120px )" : "", marginLeft: isopen ? "130px" : "" }}>
                            <div className="content-wrapper pl-2">
                                {/* <MainCotent /> */}
                                <div className="row py-3">
                                    <div className="col-12 col-md-6 col-xl-4 my-2 my-xl-0">
                                        <div className="card light-shadow mb-0 card-body Card-1  n_shadow a_card cursor-pointer  "
                                            onClick={() => navigate('/GeneralInformationGrid')}
                                        >
                                            <div className="stats ">
                                                <div className='row px-3'>
                                                    <div className='col-9'>
                                                        <h2 className='ml-2 text-color-blue'>{Countdata.GeneralInfo ? Countdata.GeneralInfo : '0'}</h2>
                                                        <p className='text-black mt-2 mt-lg-3' style={{ fontWeight: "600", marginBottom: "0px" }}>General Information</p>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <span className="icon ">
                                                            <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src='./static/assets/img/dashboard/Information.png' style={{ height: "50px" }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-4 my-2 my-xl-0">
                                        <div className="card light-shadow mb-0 card-body Card-1  n_shadow a_card cursor-pointer  "
                                            onClick={() => navigate('/BeneficiaryDetailsGrid')}
                                        >
                                            <div className="stats ">
                                                <div className='row px-3'>
                                                    <div className='col-9'>
                                                        <h2 className='ml-2 text-color-blue'>{Countdata.BeneficiaryMaster ? Countdata.BeneficiaryMaster : '0'}</h2>
                                                        <p className='text-black mt-2 mt-lg-3' style={{ fontWeight: "600", marginBottom: "0px" }}>Beneficiary Details</p>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <span className="icon ">
                                                            <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src='./static/assets/img/dashboard/Beneficiary_d.png' style={{ height: "50px" }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-4 my-2 my-xl-0">
                                        <div className="card light-shadow mb-0 card-body Card-1  n_shadow a_card cursor-pointer  "
                                            onClick={() => navigate('/PlantaionDetailsGrid')} >
                                            <div className="stats ">
                                                <div className='row px-3'>
                                                    <div className='col-9'>
                                                        <h2 className='ml-2 text-color-blue' >{Countdata.PlantationDetails ? Countdata.PlantationDetails : '0'}</h2>
                                                        <p className='text-black mt-2 mt-lg-3' style={{ fontWeight: "600", marginBottom: "0px" }}>Plantation Details</p>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <span className="icon ">
                                                            <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src='./static/assets/img/dashboard/growth.png' style={{ height: "50px" }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-4  my-2 my-xl-3">
                                        <div className="card light-shadow mb-0 card-body Card-1  n_shadow a_card cursor-pointer  "
                                            onClick={() => navigate('/BeneficiaryPlotDetailsGrid')}
                                        >
                                            <div className="stats ">
                                                <div className='row px-3'>
                                                    <div className='col-9'>
                                                        <h2 className='ml-2 text-color-blue' >{Countdata.PlotDetails ? Countdata.PlotDetails : '0'}</h2>
                                                        <p className='text-black mt-2 mt-lg-3' style={{ fontWeight: "600", marginBottom: "0px" }}>Beneficiary Plot Details</p>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <span className="icon ">
                                                            <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src='./static/assets/img/dashboard/navigation.png' style={{ height: "50px" }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-xl-4   my-2 my-xl-3">
                                        <div className="card light-shadow mb-0 card-body Card-1  n_shadow a_card cursor-pointer  "
                                            onClick={() => navigate('/SamplePlantDetailsGrid')}
                                        >
                                            <div className="stats ">
                                                <div className='row px-3'>
                                                    <div className='col-9'>
                                                        <h2 className='ml-2 text-color-blue' >{Countdata.SamplePlantDetails ? Countdata.SamplePlantDetails : '0'}</h2>
                                                        <p className='text-black mt-2 mt-lg-3' style={{ fontWeight: "600", marginBottom: "0px" }}>Sample Plant Details</p>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <span className="icon ">
                                                            <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src='./static/assets/img/dashboard/petri-dish.png' style={{ height: "50px" }} />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </>
    );
}

export default AdminDashboard;
